/**
 * @file Price Page
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-06-30 Baidu
 */

import React from 'react';
import {Table} from 'antd';
import {connect} from 'react-redux';
import {billingPackageOfMonth, billingPackageOfQuarter, billingPackageOfYear,
    billingPackageOfYear2
} from '../../common/package';

import './index.less';

class Price extends React.Component {
    render() {
        const price = {
            head: [
                {
                    title: '周期',
                    dataIndex: 'cycle',
                    key: 'cycle'
                },
                {
                    title: '定价',
                    dataIndex: 'price',
                    key: 'price'
                }
            ],
            body: [
                {
                    key: 1,
                    cycle: '按小时结算',
                    price: '10元/10000点'
                }
            ]
        };

        const billTable = {
            head: [
                {
                    title: '类型',
                    dataIndex: 'type',
                    key: 'type'
                }, {
                    title: '有效期',
                    dataIndex: 'validTime',
                    key: 'validTime'
                }, {
                    title: '点数消耗',
                    dataIndex: 'point',
                    key: 'point'
                }, {
                    title: '说明',
                    dataIndex: 'desc',
                    key: 'desc'
                },
            ],
            body: [
                {
                    key: 1,
                    type: '创建',
                    validTime: '一年期',
                    point: '1点/个',
                    desc: '按照短链进行计数，相同长链接创建不同短链会重复计数'
                }, {
                    key: 2,
                    type: '创建',
                    validTime: '长期',
                    point: '2点/个',
                    desc: '按照短链进行计数，相同长链接创建不同短链会重复计数'
                }, {
                    key: 3,
                    type: '跳转',
                    validTime: '-',
                    point: '1点/个',
                    desc: '按照服务端访问量进行计数（即PV），爬虫、服务商/运营商扫描等流量会一并进行计数'
                },
            ]
        };
        const billingDesc = '百度短网址按照创建短网址条数和短网址的跳转次数，实行阶梯定价。用户可'
            + '根据每月创建短网址条数和短网址的跳转次数购买相应的套餐包对应的点数。'
            + '用户只需要购买点数套餐包即可实现计费。';
        // const freeAllowances = '开通百度短网址服务的用户，在正常使用服务的过程中，系统每个自然月均提'
        //     + '供一定的免费额度。所有用户，每自然月免费享有100点，系统根据实际点'
        //     + '数消耗来扣除账户中的点数，免费额度过期将做作废处理。账户剩余点数不'
        //     + '足请及时购买套餐包。';
        const billingCycle = '账单时间是北京时间整点，当前每小时结算一次，出账单时间是计费周期结束后1小时内，具体以系统出账时间为准。';
        const packageDesc = '用户可以直接在充值中心的“产品购买”页面进行套餐包购买。系统优先使用'
            + '每个月免费额度，免费额度用完后，系统在计费时会优先抵扣套餐包，超出部'
            + '分再继续按照10元/10000点单价进行计费。';
        const expireRemind = '服务到期前7天、3天、1天，系统会发出短信和邮件提醒。为了避免服务中断'
            + '，请在服务到期前进行新套餐包的购买或保证充足的账户余额。服务到期后且账户余额<0时，用户无'
            + '法创建短网址，已创建的短网址将会延迟跳转，系统会通过邮件及短信发送欠费停服通知。';
        const arrearsDesc = '系统优先使用每个月免费额度，免费额度用完后，系统在计费时会优先抵扣套'
            + '餐包，超出部分再继续按照10元/万点的单价进行计费。若用户没有续费或购'
            + '买套餐包，账户余额抵扣完毕时，用户无法创建短网址，已创建的短网址将会延迟跳转。';
        const quarterlyPackage = '季度套餐包提供一个季度（3个月）有效期的点数，自购买之日起开始计时，'
            + '若到期点数没有用完，剩余点数将失效。用户需重新购买套餐包继续使用。';
        const monthlyPackage = '包月套餐包提供一个月有效期的点数，自购买之日起开始计时，若到期点数没有用完，'
            + '剩余点数将失效。用户需重新购买套餐包继续使用。';
        const yearPackage1 = '年包一：12个月的包月套餐包，每个月包逐月生效。';
        const yearPackage2 = '当月提供一个月有效期的点数，自购买之日起开始计时，若当月套餐包点数到期没有用完，'
            + '月包剩余点数将失效。若当月套餐包点数耗尽，用户需额外购买套餐包补用（或从百度云账户余额抵扣），'
            + '直到下个月的包月套餐包开始生效。';
        const yearPackage3 = '年包二：一年期的包年套餐包，每个年包逐年生效。订阅的年包互相不可继承，不可转结。';
        return (
            <div className="doc-container">
                <div className="price-content">
                    <h1>百度短网址产品价格说明</h1>
                    <h2 className="title">计费方式简介</h2>
                    <p>{billingDesc}</p>
                    <Table
                        columns={billTable.head}
                        dataSource={billTable.body}
                        pagination={false}
                        bordered={true}
                    />
                    <div style={{color: 'red'}}>提示：目前创建的短网址分一年有效和长期有效。请根据场景需要选择相应的有效期，过期后短链无法正常访问。</div>
                    {/* <h3>免费额度</h3>
                    <p>{freeAllowances}</p> */}
                    <h3>计费周期</h3>
                    <p>{billingCycle}</p>
                    {/* <h3>免费额度使用限制</h3>
                    <p>使用免费额度的用户每个月可创建不超过5个长期有效的短网址。</p> */}
                    <h3>计费方式转化</h3>
                    <p>用户购买套餐包后，优先使用每个月的免费额度，其次从套餐包中扣除消费的点数；
                        当套餐包消费完毕以后，自动转入按量付费方式。</p>
                    <h2 className="title">计费方式说明</h2>
                    <h3>按量计费（后付费）</h3>
                    <p>计费公式：费用 = 消耗点数 * 点数单价</p>
                    <h3>价格</h3>
                    <Table columns={price.head}
                           dataSource={price.body}
                           pagination={false} bordered={true}/>
                    <h2 className="title">套餐包</h2>
                    <p>{packageDesc}</p>
                    <p>套餐包价格如下：</p>
                    <Table columns={billingPackageOfQuarter.head}
                           dataSource={billingPackageOfQuarter.body}
                           pagination={false} bordered={true}/>
                    {/* 短网址包月套餐包 */}
                    <Table columns={billingPackageOfMonth.head}
                           dataSource={billingPackageOfMonth.body}
                           pagination={false} bordered={true}/>
                    {/* 短网址包年套餐包 */}
                    <Table columns={billingPackageOfYear.head}
                           dataSource={billingPackageOfYear.body}
                           pagination={false} bordered={true}/>
                    {/* 短网址包年套餐包 */}
                    <Table columns={billingPackageOfYear2.head}
                           dataSource={billingPackageOfYear2.body}
                           pagination={false} bordered={true}/>
                    <h2 className="title">套餐包说明</h2>
                    <h3>短网址季度套餐包</h3>
                    <p>{quarterlyPackage}</p>
                    <h3>短网址包月套餐包</h3>
                    <p>{monthlyPackage}</p>
                    <h3>短网址一年期订阅</h3>
                    <p>{yearPackage1}
                        <br/>{yearPackage2}
                        <br/>
                        <br/>
                        {yearPackage3}
                    <h3>高级报表套餐包</h3>
                    <p>高级报表暂不支持退款；为方便用户使用，您可以提
                        <a
                            target="_blank"
                            href="https://console.bce.baidu.com/ticket/?_=1700103019656/#/ticket/create?productId=188&questionId=706&createDirectly=1"
                        >工单</a>
                        咨询详情。
                    </p>
                    </p>
                    <h2 className="title">到期提醒和欠费说明</h2>
                    <h3>到期提醒</h3>
                    <p>{expireRemind}</p>
                    <h3>欠费说明</h3>
                    <p>{arrearsDesc}</p>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    currentPage: state.currentPage
}))(Price);
